import { withDayOut, type DayOut } from "@/lib/companion/day-out";
import Link from "next/link";
import type { CompanionPeopleSquad } from "@/lib/companion/people-loop";

export function CompanionPeopleFilters({
  squads,
  selectedSquadId,
  selectedDate,
  today,
  tomorrow,
  baseId,
  dayOut,
}: {
  squads: CompanionPeopleSquad[];
  selectedSquadId: string | null;
  selectedDate: string;
  today: string;
  tomorrow: string;
  baseId?: string | null;
  dayOut?: DayOut | null;
}) {
  function href(day: string, squadId: string | null): string {
    const params = new URLSearchParams();
    if (baseId) params.set("base", baseId);
    params.set("day", day);
    if (squadId) params.set("squad", squadId);
    return withDayOut(`/companion/people?${params.toString()}`, dayOut);
  }

  return (
    <div className="grid gap-3 sm:grid-cols-[auto_minmax(0,1fr)] sm:items-end">
      <div>
        <p className="mb-2 text-[10px] font-semibold uppercase tracking-[1.4px] text-white/60">
          Day
        </p>
        <div aria-label="Roll-call day" className="inline-flex rounded-sm border border-white/15 bg-white/5 p-1">
          {[
            { id: today, label: "Today" },
            { id: tomorrow, label: "Tomorrow" },
          ].map((day) => {
            const active = selectedDate === day.id;
            return (
              <Link
                key={day.id}
                href={href(day.id, selectedSquadId)}
                aria-current={active ? "page" : undefined}
                className={`inline-flex min-h-[44px] items-center rounded-sm px-4 text-[13px] font-semibold no-underline ${active ? "bg-teal text-white" : "text-white/75 hover:bg-white/10 hover:text-white"}`}
              >
                {day.label}
              </Link>
            );
          })}
        </div>
      </div>

      <div className="sm:justify-self-end">
        <p className="mb-2 text-[10px] font-semibold uppercase tracking-[1.4px] text-white/60">
          Squad
        </p>
        <div className="flex flex-wrap gap-2" aria-label="Squad filter">
          <Link
            href={href(selectedDate, null)}
            aria-current={!selectedSquadId ? "page" : undefined}
            className={`inline-flex min-h-[44px] items-center rounded-sm border px-3 text-[12px] font-semibold no-underline ${!selectedSquadId ? "border-teal-light bg-teal text-white" : "border-white/15 text-white/75 hover:border-white/30 hover:text-white"}`}
          >
            All Squads
          </Link>
          {squads.map((squad) => {
            const active = selectedSquadId === squad.id;
            return (
              <Link
                key={squad.id}
                href={href(selectedDate, squad.id)}
                aria-current={active ? "page" : undefined}
                className={`inline-flex min-h-[44px] items-center rounded-sm border px-3 text-[12px] font-semibold no-underline ${active ? "border-teal-light bg-teal text-white" : "border-white/15 text-white/75 hover:border-white/30 hover:text-white"}`}
              >
                {squad.name}
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
